import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registerEvent } from '../utils/google-analytics.js';
import { border } from '../utils/theme.js';
import Box from '@mui/material/Box';
import CheckImg from '../assets/images/certificates/change_data.png';
import CertificateChangeDataDialog from './ui/CertificateChangeDataDialog.jsx';
import GenericSingleOptionalActionDialog from './ui/GenericSingleOptionalActionDialog.jsx';
import { StateType } from '@pok/minter-sdk';

export default function CertificateChangeData({ certificate }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [changeInProgress, setChangeInProgress] = useState(false);
    const sendEvent = (method) => registerEvent(`changedata-${method}`);

    const handleOnClick = () => {
        [StateType.CHANGE_REQUESTED, StateType.CHANGE_APPROVED].includes(certificate.currentState)
            ? setChangeInProgress(true)
            : setOpen(true);
    };
    return (
        <>
            <Box
                sx={{
                    ...border,
                    borderRadius: 4,
                    paddingX: 2,
                    paddingY: 2,
                }}
            >
                <Stack direction="row" spacing={1}>
                    <img src={CheckImg} alt="check" height={24} style={{ marginTop: '6px' }} />
                    <Stack>
                        <Typography variant="caption" fontWeight={700} pb={1} pr={1}>
                            {t('certificate.change_data_title')}
                        </Typography>
                        <a style={{ textDecoration: 'none' }} onClick={handleOnClick}>
                            <Typography variant="link" sx={{ cursor: 'pointer' }} fontWeight={700} fontSize={12}>
                                {t('certificate.change_data_link')}
                            </Typography>
                        </a>
                    </Stack>
                </Stack>
            </Box>
            {open && (
                <CertificateChangeDataDialog
                    onClose={() => setOpen(false)}
                    open={open}
                    onSendEvent={sendEvent}
                    certificate={certificate}
                />
            )}
            <GenericSingleOptionalActionDialog
                onClose={() => setChangeInProgress(false)}
                open={changeInProgress}
                title={t('certificate.change_data.change_in_progress.title')}
                subtitle={t('certificate.change_data.change_in_progress.subtitle')}
            />
        </>
    );
}
